import clsx from 'clsx';

function CustomSelect({ value, onChange, options, className = '', isMobile = false }) {
    const selectClasses = clsx(
        'tw-py-4 tw-pr-12 tw-pl-5 tw-border tw-border-gray-300 tw-rounded-md tw-text-black tw-cursor-pointer tw-bg-white tw-appearance-none',
        isMobile 
            ? 'tw-w-[175px] tw-text-lg tw-font-["Poppins"] tw-font-semibold' 
            : 'tw-w-full tw-text-base md:tw-text-2xl tw-font-["Poppins"] tw-font-semibold tw-leading-[140%]',
        className
    );
    
    const selectWrapperClasses = clsx('tw-relative', isMobile ? 'tw-w-[175px]' : '');
    
    const dropdownIconStyle = { 
        pointerEvents: 'none', 
        position: 'absolute', 
        top: 0, 
        bottom: 0, 
        right: 0, 
        display: 'flex', 
        alignItems: 'center', 
        paddingRight: '12px', 
        zIndex: 10 
    };

    const optionStyle = {
        fontFamily: 'Poppins, sans-serif',
        fontWeight: '600'
    };

    return (
        <div className={selectWrapperClasses}>
            <select
                value={value}
                onChange={onChange}
                className={selectClasses}
            >
                {options.map((option, i) => (
                    <option key={i} value={option.value} style={optionStyle}>
                        {option.label}
                    </option>
                ))}
            </select>
            <div style={dropdownIconStyle}>
                <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 5L4 8L7 5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
        </div>
    );
}

export default CustomSelect;
